import { skillAcquisitionTargetActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  masterData: null,
  skillAcquisitionTargetList: null,
  skillAcquisitionTargetDetail: null,
  saved_skillAcquisitionTarget: null,
  save_copyPatientSkillAcquisitionTarget: null,
  deleted_skillAcquisitionTarget: null,
  targetActiveStatus: false,
  targetStatus: false,
  skillAcqCollectedDTTDataByTargetId: null,
  skillAcqCollectedTADataByTargetId: null,

  updatedSkillAcqCollectedDTTData: null,
  updatedSkillAcqCollectedTAData: null,

  updatedSkillAcqCollectedDTTDataPromptCode: null,
  updatedSkillAcqCollectedTADataPromptCode: null,

  deletedSkillAcqCollectedDTTData: null,
  deletedSkillAcqCollectedTAData: null,

  skillAcquisitionTargetSingleGraphData: null,
  batchTargetStatus_updated: null,
  saved_rawSkillAquisitionBehaviordata: null,
  skillAcquisitionBehaviorCollactDataListByTargetId: null,
  deleted_skillAcquisitionbehaviorCollactData: null,
  updatedCollectedSkillAcquisitionBehaviorDataStatus: null,
  isEventOccureSkillAcq: false,
  isEventOccureSABCollactDataListByTargetId:false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case skillAcquisitionTargetActionTypes.get_masterData.REQUEST:
    case skillAcquisitionTargetActionTypes.target_active_status.REQUEST:
    case skillAcquisitionTargetActionTypes.patch_target__status.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case skillAcquisitionTargetActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
    case skillAcquisitionTargetActionTypes.save_skillAcquisitionTarget.REQUEST:
      return {
        ...state,
        loading: true,
        saved_skillAcquisitionTarget: null,
      };
    case skillAcquisitionTargetActionTypes.save_skillAcquisitionTarget.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_skillAcquisitionTarget: payload,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetList.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionTargetList: null,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetList.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionTargetList: payload,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetDetail.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionTargetDetail: null,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcquisitionTargetDetail.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionTargetDetail: payload,
      };
    case skillAcquisitionTargetActionTypes.delete_skillAcquisitionTarget.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_skillAcquisitionTarget: null,
      };
    case skillAcquisitionTargetActionTypes.delete_skillAcquisitionTarget.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_skillAcquisitionTarget: payload,
              };
    case skillAcquisitionTargetActionTypes.target_active_status.SUCCESS:
      return {
        ...state,
        targetActiveStatus: payload,
        loading: false,
      };
    case skillAcquisitionTargetActionTypes.patch_target__status.SUCCESS:
      return {
        ...state,
        targetStatus: payload,
        loading: false,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcqCollectedDTTDataBytTargetId.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcqCollectedDTTDataByTargetId: null,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcqCollectedDTTDataBytTargetId.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcqCollectedDTTDataByTargetId: payload,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcqCollectedTADataBytTargetId.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcqCollectedTADataByTargetId: null,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcqCollectedTADataBytTargetId.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcqCollectedTADataByTargetId: payload,
      };
    case skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataStatus.REQUEST:
      return {
        ...state,
        loading: true,
        updatedSkillAcqCollectedDTTData: null,
      };
    case skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataStatus.SUCCESS:
      return {
        ...state,
        loading: false,
        updatedSkillAcqCollectedDTTData: payload,
      };
    case skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataStatus.REQUEST:
      return {
        ...state,
        loading: true,
        updatedSkillAcqCollectedTAData: null,
      };
    case skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataStatus.SUCCESS:
      return {
        ...state,
        loading: false,
        updatedSkillAcqCollectedTAData: payload,
      };
    case skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataPromtCode.REQUEST:
      return {
        ...state,
        loading: true,
        updatedSkillAcqCollectedDTTDataPromptCode: null,
      };
    case skillAcquisitionTargetActionTypes.update_skillAcqCollectedDTTDataPromtCode.SUCCESS:
      return {
        ...state,
        loading: false,
        updatedSkillAcqCollectedDTTDataPromptCode: payload,
      };
    case skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataPromtCode.REQUEST:
      return {
        ...state,
        loading: true,
        updatedSkillAcqCollectedTADataPromptCode: null,
      };
    case skillAcquisitionTargetActionTypes.update_skillAcqCollectedTADataPromtCode.SUCCESS:
      return {
        ...state,
        loading: false,
        isEventOccureSkillAcq:true,
        updatedSkillAcqCollectedTADataPromptCode: payload,
      };
    case skillAcquisitionTargetActionTypes.delete_skillAcqCollectedDTTData.REQUEST:
      return {
        ...state,
        loading: true,
        deletedSkillAcqCollectedDTTData: null,
      };
    case skillAcquisitionTargetActionTypes.delete_skillAcqCollectedDTTData.SUCCESS:
      return {
        ...state,
        loading: false,
        deletedSkillAcqCollectedDTTData: payload,
      };
    case skillAcquisitionTargetActionTypes.delete_skillAcqCollectedTAData.REQUEST:
      return {
        ...state,
        loading: true,
        deletedSkillAcqCollectedTAData: null,
      };
    case skillAcquisitionTargetActionTypes.delete_skillAcqCollectedTAData.SUCCESS:
      return {
        ...state,
        loading: false,
        deletedSkillAcqCollectedTAData: payload,
      };
    case skillAcquisitionTargetActionTypes.save_copyPatientSkillAcquisitionTarget.REQUEST:
        return {
          ...state,
          loading: true,
          save_copyPatientSkillAcquisitionTarget: null,
        };
    case skillAcquisitionTargetActionTypes.save_copyPatientSkillAcquisitionTarget.SUCCESS:
        return {
          ...state,
          loading: false,
          save_copyPatientSkillAcquisitionTarget: payload,
        };
    case skillAcquisitionTargetActionTypes.get_getPatientSkillAcquisitionTargetSingleGraph.REQUEST:
      return {
        ...state,
        loading: true,
        skillAcquisitionTargetSingleGraphData: null,
      };
    case skillAcquisitionTargetActionTypes.get_getPatientSkillAcquisitionTargetSingleGraph.SUCCESS:
      return {
        ...state,
        loading: false,
        skillAcquisitionTargetSingleGraphData: payload,
      };
    case skillAcquisitionTargetActionTypes.update_batch_target_status.REQUEST:
        return {
          ...state,
          loading: true,
          batchTargetStatus_updated: null,
        };
    case skillAcquisitionTargetActionTypes.update_batch_target_status.SUCCESS:
        return {
          ...state,
          loading: false,
          batchTargetStatus_updated: payload,
        };
    case skillAcquisitionTargetActionTypes.update_batch_active_status.REQUEST:
        return {
          ...state,
          loading: true,
          batchTargetStatus_updated: null,
        };
    case skillAcquisitionTargetActionTypes.update_batch_active_status.SUCCESS:
        return {
          ...state,
          loading: false,
          batchTargetStatus_updated: payload,
        };
    case skillAcquisitionTargetActionTypes.save_rawskillaquisitionbehaviordata.REQUEST:
      return {
        ...state,
        loading: true,
        saved_rawSkillAquisitionBehaviordata: null,
      };
    case skillAcquisitionTargetActionTypes.save_rawskillaquisitionbehaviordata.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_rawSkillAquisitionBehaviordata: payload,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcquisitionBehaviorCollactDataListByTargetId.REQUEST:
          return {
        ...state,
        loading: true,
                skillAcquisitionBehaviorCollactDataListByTargetId: null,
      };
    case skillAcquisitionTargetActionTypes.get_skillAcquisitionBehaviorCollactDataListByTargetId.SUCCESS:
          return {
        ...state,
        loading: false,
        isEventOccureSABCollactDataListByTargetId:true,
        skillAcquisitionBehaviorCollactDataListByTargetId: payload,
      };
    case skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_skillAcquisitionbehaviorCollactData: null,
      };
    case skillAcquisitionTargetActionTypes.delete_skillAquisitionBehaviorCollactData.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_skillAcquisitionbehaviorCollactData: payload,
      };
    case skillAcquisitionTargetActionTypes.update_collectedSkillAquisitionBehaviorDataStatus.REQUEST:
      return {
        ...state,
        loading: true,
        updatedCollectedSkillAcquisitionBehaviorDataStatus: null,
      };
    case skillAcquisitionTargetActionTypes.update_collectedSkillAquisitionBehaviorDataStatus.SUCCESS:
      return {
        ...state,
        loading: false,
        updatedCollectedSkillAcquisitionBehaviorDataStatus: payload,
      };
    
    case skillAcquisitionTargetActionTypes.setIsEventOccureSkillAcqFalse.SUCCESS:
      return{
        ...state,
        isEventOccureSkillAcq:false
      }
    case skillAcquisitionTargetActionTypes.setIsEventOccureSABCollactDataListByTargetIdFalse.SUCCESS:
      return {
        ...state,
        isEventOccureSABCollactDataListByTargetId:false
      }
    default:  
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Target/reducers/skillAquisitionTargetReducer.js